import React from 'react';
import { ShieldCheck, Youtube, Facebook, DollarSign, Eye, TrendingUp } from 'lucide-react';
import { Button } from './ui/button';

const features = [
  {
    icon: Youtube,
    title: 'YouTube Content ID',
    desc: 'Deteksi otomatis penggunaan lagu Anda di seluruh YouTube dan claim monetisasi',
  },
  {
    icon: Facebook,
    title: 'Facebook Rights Manager',
    desc: 'Lindungi karya di Facebook dan Instagram dengan sistem deteksi Meta',
  },
  {
    icon: DollarSign,
    title: 'Monetisasi Otomatis',
    desc: 'Dapatkan royalti dari setiap video yang menggunakan lagu Anda',
  },
  {
    icon: Eye,
    title: 'Monitoring 24/7',
    desc: 'Tim kami memantau penggunaan lagu Anda di seluruh platform',
  },
];

const CopyrightSection = () => {
  return (
    <section className="relative py-24 lg:py-32 overflow-hidden bg-[#080808]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left */}
          <div>
            <div className="inline-block px-4 py-1.5 rounded-full border border-[#D4A94F]/30 bg-[#D4A94F]/5 mb-5">
              <span className="text-xs font-medium tracking-widest uppercase text-[#E9C46A]">
                Copyright Manager
              </span>
            </div>
            <h2 className="text-white font-bold text-4xl md:text-5xl leading-tight tracking-tight mb-5">
              Lindungi Hak Cipta{' '}
              <span className="gold-gradient-text">Karya Anda</span>
            </h2>
            <p className="text-neutral-400 text-lg leading-relaxed mb-8">
              Kami membantu Anda melindungi penggunaan musik di seluruh internet.
              Setiap video yang mengandung lagu Anda di YouTube & Facebook akan
              terdeteksi dan dimonetisasi otomatis.
            </p>

            <div className="grid sm:grid-cols-2 gap-5 mb-10">
              {features.map((f) => (
                <div key={f.title} className="flex gap-3">
                  <div className="flex-shrink-0 w-11 h-11 rounded-xl bg-[#D4A94F]/10 border border-[#D4A94F]/25 flex items-center justify-center">
                    <f.icon className="w-5 h-5 text-[#E9C46A]" strokeWidth={2} />
                  </div>
                  <div>
                    <h4 className="text-white font-semibold text-base mb-1">{f.title}</h4>
                    <p className="text-neutral-500 text-sm leading-relaxed">{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <Button className="h-13 px-8 py-3 rounded-full bg-gradient-to-r from-[#E9C46A] to-[#D4A94F] text-black font-semibold btn-transition gold-shimmer hover:shadow-[0_10px_40px_-10px_rgba(212,169,79,0.6)]">
              <ShieldCheck className="mr-2 w-4 h-4" />
              Aktifkan Copyright Manager
            </Button>
          </div>

          {/* Right visual */}
          <div className="relative">
            <div className="relative aspect-square max-w-md mx-auto">
              {/* Big golden ring */}
              <div className="absolute inset-0 rounded-full border border-[#D4A94F]/20 animate-spin-slow" />
              <div className="absolute inset-8 rounded-full border border-[#D4A94F]/15" />
              <div className="absolute inset-16 rounded-full border border-[#D4A94F]/10" />

              {/* Center shield */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="relative">
                  <div className="absolute inset-0 bg-[#D4A94F]/25 blur-3xl glow-pulse" />
                  <div className="relative w-40 h-40 rounded-full bg-gradient-to-br from-[#E9C46A] via-[#D4A94F] to-[#B8892C] flex items-center justify-center shadow-[0_20px_60px_-10px_rgba(212,169,79,0.5)]">
                    <ShieldCheck className="w-16 h-16 text-black" strokeWidth={2} />
                  </div>
                </div>
              </div>

              {/* Orbiting cards */}
              <div className="absolute top-8 -left-4 md:-left-6 bg-[#111] border border-white/10 rounded-xl p-3 shadow-2xl flex items-center gap-2">
                <Youtube className="w-5 h-5 text-red-500" />
                <span className="text-xs text-white font-medium">Content ID Active</span>
              </div>
              <div className="absolute bottom-16 -right-4 md:-right-6 bg-[#111] border border-white/10 rounded-xl p-3 shadow-2xl flex items-center gap-2">
                <Facebook className="w-5 h-5 text-blue-500" />
                <span className="text-xs text-white font-medium">Rights Manager</span>
              </div>
              <div className="absolute bottom-4 left-10 bg-[#111] border border-[#D4A94F]/40 rounded-xl p-3 shadow-2xl flex items-center gap-2">
                <TrendingUp className="w-4 h-4 text-emerald-400" />
                <div>
                  <p className="text-[10px] text-neutral-400">Claims Bulan Ini</p>
                  <p className="text-xs text-white font-bold">+3,240</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CopyrightSection;
